import { Observable } from 'rxjs';
import { OrdersReceivedModelKeys } from '../models/orders-received.model';

export abstract class OrdersReceivedRepository {
    abstract getOrdersReceived<T>(
        config: OrdersReceivedModelKeys,
    ): Observable<T>;
}
